import { render, staticRenderFns } from "./DashboardDoctor.html?vue&type=template&id=68a7d532&lang=html&external"
import script from "./DashboardDoctor.vue?vue&type=script&lang=js"
export * from "./DashboardDoctor.vue?vue&type=script&lang=js"
import style0 from "./DashboardDoctor.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports